import type { BookingStatus } from '@/shared/api'

/**
 * Признаки вида пилюли брони, вычисленные из статуса: сервер их не шлёт, только
 * `status`/`source`/`amountLabel` (`docs/reference/phase-3-mockup.md` §6). Имя берётся контрактное —
 * `cancelled`, а не `cancel` макета.
 *
 * Прямое сравнение, а не `serverMap`/`pick`: та дверь нужна, когда незнакомому значению надо НАЗВАТЬ
 * фолбэк среди нескольких. Здесь он получается сам — ни одно `===` не совпадёт, и функция вернёт
 * пять `false`, то есть нейтральную пилюлю, ничего не утверждающую.
 */
export type PillStatusFlags = {
  isIn: boolean
  isPending: boolean
  dim: boolean
  strikethrough: boolean
  /** Финальное решение — НА СТОРОНЕ ВЫЗЫВАЮЩЕГО: он сверяет ещё `amountLabel !== null`, потому что
   *  сумма может не прийти и в этих статусах, а `pillStatusFlags` о ней не знает вовсе. */
  showsAmount: boolean
}

export function pillStatusFlags(status: BookingStatus): PillStatusFlags {
  /*
   * ⚠️ `blocked` НЕ ПРИГЛУШАЕТСЯ, хотя гостя там нет вовсе: приглушение значит «уже не актуально», а
   * закрытый под обслуживание период актуален так же, как подтверждённая бронь — квартиру в эти даты
   * не занять. `no_show` приглушается: у их таблицы переходов выходов из него нет, то есть
   * проживания не будет уже никогда.
   */
  const dim = status === 'checked_out' || status === 'cancelled' || status === 'no_show'
  return {
    isIn: status === 'checked_in',
    isPending: status === 'pending',
    dim,
    strikethrough: status === 'cancelled',
    // У блокировки суммы нет по определению, а `no_show` про деньги не отвечает.
    showsAmount: status === 'checked_in' || status === 'confirmed',
  }
}
